import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@/utilities/seo";

export const Route = createFileRoute("/_home/compare")({
  component: ComparePage,
  head: () => ({
    meta: [
      { title: "Compare - ProgressMade.ai" },
      ...seo({
        title: "Compare - ProgressMade.ai",
        description: "Compare ProgressMade.ai with other health apps",
        keywords: "compare, health apps, health, fitness, wellness",
        image: "https://progressmade.ai/meta-image.webp",
        canonical: "https://progressmade.ai/compare",
      }),
    ],
  }),
});

function ComparePage() {
  return <div>Hello "/_home/compare"!</div>;
}
